import { LinkButton } from '../Link/LinkButton';
import {
  Table,
  TableBody,
  TableCaption,
  TableCell,
  TableRow,
} from '../Table/Table';
import { PublisherInfoTableProps } from './types';

export const PublisherInfoTable = ({
  supportContact,
  website,
  organizationName,
  publisherProfile,
  microcopy,
  className = '',
}: PublisherInfoTableProps) => {
  return (
    <Table className={className}>
      <TableCaption>{microcopy.title}</TableCaption>
      <TableBody>
        <TableRow>
          <TableCell>{microcopy.supportContact}</TableCell>
          <TableCell>{supportContact}</TableCell>
        </TableRow>

        {website && (
          <TableRow>
            <TableCell>{microcopy.website}</TableCell>
            <TableCell>
              <LinkButton
                className="font-normal capitalize text-blue no-underline"
                openLinkInNewTab
                label={microcopy.website}
                href={website}
                hasIcon
              />
            </TableCell>
          </TableRow>
        )}

        <TableRow>
          <TableCell>{microcopy.verifiedOrganizationName}</TableCell>
          <TableCell>{organizationName}</TableCell>
        </TableRow>

        {publisherProfile && (
          <TableRow>
            <TableCell>{microcopy.publisherDetails}</TableCell>
            <TableCell className="[&_a]:no-underline [&_span]:no-underline">
              <LinkButton
                className="font-normal capitalize text-blue no-underline"
                openLinkInNewTab
                label={microcopy.publisherDetails}
                href={publisherProfile}
              />
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  );
};
